import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";

// WordPress slug of the live page this old URL redirects to (a hard redirect on the published site).
const SLUG = "screening-and-separation-hub";
const TARGET = `/${SLUG}`;
export default function ScreeningAndSeparationPage() {
  const [lang, setLang] = useState<"en" | "zh">("en");
  useEffect(() => {
    try {
      const stored = localStorage.getItem("mf_lang");
      if (stored === "zh" || stored === "en") {
        setLang(stored);
      }
    } catch {
      // safe fallback
    }
    const handleLangChange = (e: Event) => {
      const customEvent = e as CustomEvent<{
        lang?: string;
      }>;
      if (customEvent?.detail?.lang === "zh" || customEvent?.detail?.lang === "en") {
        setLang(customEvent.detail.lang);
        return;
      }
      try {
        const current = localStorage.getItem("mf_lang");
        if (current === "zh" || current === "en") {
          setLang(current);
        }
      } catch {
        // safe fallback
      }
    };
    const handleStorage = (e: StorageEvent) => {
      if (e.key === "mf_lang" && (e.newValue === "zh" || e.newValue === "en")) {
        setLang(e.newValue);
      }
    };
    window.addEventListener("mf-language-change", handleLangChange);
    window.addEventListener("storage", handleStorage);
    window.location.replace(TARGET);
    return () => {
      window.removeEventListener("mf-language-change", handleLangChange);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);
  const isZh = lang === "zh";
  return <main className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="text-center space-y-4">
        <p className="text-base text-muted-foreground">
          {isZh ? "正在跳转…" : "Redirecting…"}
        </p>
        <div>
          <Link href={TARGET} className="text-sm font-medium text-foreground underline underline-offset-4 hover:text-primary transition-colors">
            {isZh ? "继续" : "Continue"}
          </Link>
        </div>
      </div>
    </main>;
}